// extracted by mini-css-extract-plugin
export default {"menuButton":"COpGyXlv4AQQjNjJrLRH","menuItems":"LIwdj2vbORuNrxcep92y","menuItem":"NGIM6fnr2uEwyoEwMAWZ"};